import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { IconButton, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

DeleteIconButton.propTypes = {
  onClick: PropTypes.func,
  tooltipText: PropTypes.string,
  disableRipple: PropTypes.bool
};

export default function DeleteIconButton({ onClick, tooltipText = "Delete", disableRipple = false }) {
  return (
    <Tooltip title={tooltipText} arrow>
      <IconButton disableRipple={disableRipple} edge="end" color="error" onClick={onClick} sx={disableRipple ? { p: 0, mr: 0.5 } : { mr: 0.5 }}>
        <DeleteOutlineIcon />
      </IconButton>
    </Tooltip>
  );
}
